export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11972.f984c17e.jpg";